import Session from "./session";

const Authentication = {
  authenticate: ({ accessToken = "", tenantId = -1 }) => {
    Session.accessToken = accessToken;
    Session.loggedIn = true;
    Session.tenantId = tenantId;
  },

  clear() {
    Session.clearSession();
  },

  verify() {
    return !!Session.accessToken;
  },
};

export default Authentication;
